import { useState, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal, Fade, Backdrop, Grid, Paper, TextField, FormControl, InputLabel, Select, MenuItem, Typography,
  FormHelperText } from '@material-ui/core'
import { getExaminationList, getUserClassrooms, getFacultyList } from 'containers/Examination/ExaminationService'
import { StateContext, DispatchContext } from 'context/Provider'

import './DashboardActions.css'
import { Form } from 'formik'

const DashboardActions = () => {
  const history = useHistory()

  const appState = useContext(StateContext)
  const { authState } = appState

  const [newExamModal, setNewExamModal] = useState(false)

  const closeNewExamModal = () => {
    setNewExamModal(false)
  }

  const openNewExamModal = (e) => {
    e.preventDefault()
    setNewExamModal(true)
  }

  const [classrooms, setClassrooms] = useState({})
  const [faculties, setFaculties] = useState({})

  const [name, setName] = useState('')
  const [showNameError, setShowNameError] = useState(false)
  const [nameError, setNameError] = useState('')

  const [description, setDescription] = useState('')
  const [showDescriptionError, setShowDescriptionError] = useState(false)
  const [descriptionError, setDescriptionError] = useState('')

  const [classroom, setClassroom] = useState('')
  const [showClassroomError, setShowClassroomError] = useState(false)
  const [classroomError, setClassroomError] = useState('')

  const [assignedFaculty, setAssignedFaculty] = useState('')
  const [assignedFacultyError, setAssignedFacultyError] = useState('')
  const [showAssignedFacultyError, setShowAssignedFacultyError] = useState(false)

  const [creating, setCreating] = useState(false)

  const handleSelectFaculty = (e) => {
    setAssignedFaculty(e.target.value)
  }

  const createQuiz = (e) => {
    e.preventDefault()

    if (creating) return

    const payload = {
      name,
      description,
      classroom
    }

    if (authState.user.school_id === 29 && authState.user.role_id === 3) {
      payload.faculty_id = assignedFaculty
    }

    let hasError = false

    setNameError('')
    setShowNameError(false)

    setShowAssignedFacultyError(false)
    setAssignedFacultyError('')

    if (authState.user.school_id === 29 && authState.user.role_id === 3) {
      if (assignedFaculty === null || assignedFaculty === "") {
        setAssignedFacultyError('This field is required')
        setShowAssignedFacultyError(true)
        hasError = true
      }
    }

    if (name === null || name === "") {
      setShowNameError(true)
      setNameError('This field is required')
      hasError = true
    }

    setShowDescriptionError(false)
    setDescriptionError('')

    if (description === null || description === "") {
      setShowDescriptionError(true)
      setDescriptionError("This field is required")
      hasError = true
    }

    setClassroomError('')
    setShowClassroomError(false)

    if (classroom === null || classroom == "") {
      setShowClassroomError(true)
      setClassroomError("This field is required")
      hasError = true
    }

    if (hasError) return

    setCreating(true)

    getExaminationList(payload).then((response) => {
      let responseBody = response.data

      if (!responseBody.success) {
        console.log(responseBody.message)
      }

      setCreating(false)

      history.push(`/examinations/${responseBody.examination.id}/edit`)
    })
  }

  const getClassrooms = async () => {
    let classrooms = await getUserClassrooms()
    setClassrooms(classrooms)
  }

  const getFaculties = async () => {
    let faculties = await getFacultyList()
    setFaculties(faculties)
  }

  useEffect(() => {
    getClassrooms()

    if (authState.user.school_id === 29 && authState.user.role_id === 3) {
      getFaculties()
    }
  }, [])

  return (
    <div className='dashboard-actions'>
      <Typography variant="h5" component="h1">All Examinations</Typography>
      <Button
        variant="contained"
        color="primary"
        href="/"
        onClick={(e) => openNewExamModal(e)}
      >
        <i className="fa fa-plus-circle"></i> &nbsp; New Examination
      </Button>

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={newExamModal}
        onClose={closeNewExamModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={newExamModal}>
          <Grid container md={8} lg={6} className="new-examination-modal">
            <Paper className="new-examination-container">

              {authState.user.school_id === 29 && authState.user.role_id === 3 &&
              <FormControl error={showAssignedFacultyError} fullWidth>
                <InputLabel>Assign a Faculty</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={assignedFaculty}
                  onChange={handleSelectFaculty}
                  fullWidth
                >
                  {faculties.length > 0 && faculties.map((faculty) => (
                    <MenuItem key={faculty.id} value={faculty.id}>{faculty.name}</MenuItem>
                  ))}
                </Select>
                {showAssignedFacultyError === true && <FormHelperText error={true}>{assignedFacultyError}</FormHelperText>}
              </FormControl>}

              <TextField
                label="What do you want to call your examination?"
                helperText={nameError}
                fullWidth
                error={showNameError}
                onChange={(e) => setName(e.target.value)}
              />

              <TextField
                label="A short description of the examination?"
                helperText={descriptionError}
                fullWidth
                error={showDescriptionError}
                onChange={(e) => setDescription(e.target.value)}
              />

              <FormControl fullWidth>
                <InputLabel id="class" error={showClassroomError}>Classroom</InputLabel>
                <Select
                  labelId="class"
                  value={classroom}
                  onChange={(e) => setClassroom(e.target.value)}
                  error={showClassroomError}
                >
                  {classrooms.length > 0 && classrooms.map((c) => (
                    <MenuItem value={c.class_code} key={c.class_code}>{`${c.class_code} - ${c.name}`}</MenuItem>
                  ))}
                </Select>
                {showClassroomError === true && <FormHelperText error={true}>{classroomError}</FormHelperText>}
              </FormControl>

              <div style={{display: 'flex', justifyContent: 'end'}}>
                <a href="/" style={{
                    backgroundColor: '#EF6527',
                    padding: '10px',
                    borderRadius: '7px',
                    color: 'white',
                  }}
                  onClick={createQuiz}
                >
                  {!creating && <><i className="fa fa-plus-circle"></i> Create</>}
                  {creating && <><i className="fa fa-spinner fa-spin"></i> Create</>}
                </a>
              </div>
            </Paper>
          </Grid>
        </Fade>
      </Modal>
    </div>
  )
}

export default DashboardActions